import { Badge } from '@chakra-ui/react';
import { SimpleArtist } from '../../domain/models/locations/SimpleArtist';
import { SimpleMember } from '../../domain/models/locations/SimpleMember';
import { ReactComponent as LeaderIcon } from '../../icons/leader.svg';

interface EventBoxProps {
  baseImageUrl: string;
  eventName: string;
  organizerTwitterId?: string;
  members?: SimpleMember[];
  artist?: SimpleArtist;
  isOpenNewTab: boolean;
  onClick: () => void; // Added onClick to Props
}

export const EventBox: React.FC<EventBoxProps> = ({
  baseImageUrl,
  eventName,
  organizerTwitterId,
  members,
  artist,
  onClick
}) => {
  return (
    <div onClick={onClick}>
      <div className="flex flex-row rounded-[12px] p-[16px] gap-[9px] border-[1px] border-separator-light-2 dark:border-separator-dark-1">
        <img
          src={baseImageUrl}
          alt="event_image"
          className="w-[60px] h-[83px] aspect-[60/83] rounded-[6px] object-cover"
        />
        <div className="flex flex-col justify-between">
          <div>
            <div className="text-main-light-1 dark:text-main-dark-1 font-semibold text-[15px] leading-[20px] truncate">
              {eventName}
            </div>
          </div>
          <div className="flex flex-col gap-[5px]">
            <div className="flex flex-row items-center gap-[4px]">
              <LeaderIcon className="flex-shrink-0 w-[14px] h-[14px] fill-sub-light-1 dark:fill-sub-dark-1" />
              <div className="text-main-light-4 dark:text-main-dark-4 font-normal text-[13px] leading-[16px] truncate">
                {organizerTwitterId}
              </div>
            </div>
            {members && members.length > 0
              ? RenderBadge(members.map((member) => member.name).join(', '))
              : artist
                ? RenderBadge(artist.name)
                : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const RenderBadge = (content: string) => (
  <Badge
    className="text-onSecondary-light dark:text-[#E2E8F0] bg-secondary-light dark:bg-[rgba(226,232,240,0.16)] mt-0 px-2 py-1 rounded-md text-[11px] font-semibold leading-[13px] w-fit"
    style={{
      fontSize: '11px',
      WebkitTextSizeAdjust: 'none'
    }}
  >
    {content}
  </Badge>
);
